/**
 * 回收站
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import {Table, Input, Checkbox, Button, Tabs, Modal, Pagination} from "antd";
import '../../components/TableList.css'
import Position from '../../components/Position'
import {formatTime, changeSize} from "../../../../utils";
import {message} from '../../components/Mess'
import PageTableComponent from "../../components/pageTable/PageTable";
import {HEADER_HEIGHT} from "../../../../constants";
import Detailpage from "../../components/DetailPage";
import {Scrollbars} from "react-custom-scrollbars";

const {Search} = Input;
const {TabPane} = Tabs;
const {confirm} = Modal;

export default class Recycle extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            searchText: '',//搜索的文字
            backList: [],//返回列表
            page: 1,
            size: 10,
            data: [],
            tabList: [],//获取的tabList
            currentName: '',//当前选中tablist 的名字
            currentObj: {},//tabList 选中的对象  获取列表的时候用
            checkList: [],//当前选中的item,
            count: 0,
            first: true,
            resourceType: '',
            currentId: '',
            RootId: '',
            recycle: '',
            selectedRowKeys: [],//选中的数字
            recycleType: '',//回收站的类型 是全部资源 还是个人资源 还是部门资源

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let recycle = this.props.match.params.recycle;
        this.setState({recycle: recycle,});
        this.getResourceName(recycle)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (parseInt(this.state.recycle) !== nextProps.match.params.recycle) {
            let recycle = nextProps.match.params.recycle;
            this.getResourceName(recycle)
        }
    }

    getResourceName(resource) {
        this.setState({searchText: '', resourceType: resource, first: true});

        let department = window.top.currentUser.deptList[0].name;
        let user = window.top.currentUser.name;
        if (resource === 'all') {
            this.state.backList = [{name: '全部资源', id: 0}, {name: '回收站', id: 1}];
            this.state.recycleType = 'all'
        } else if (resource === 'dept') {
            this.state.backList = [{name: department, id: 0}, {name: '回收站', id: 1}];
            this.state.recycleType = 'dept'
        } else if (resource === 'person') {
            this.state.backList = [{name: user, id: 1}, {name: '回收站', id: 2}];
            this.state.recycleType = 'person'
        }
        this.setState({}, () => {
            this.getList()
        })
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 32 ;
        return (
            <div style={{background: '#ffffff', padding: '24px 15px',  margin: "15px 0 15px 15px",borderRadius:5, maxHeight: height}}>
                {this.renderBtn()}
                {/*渲染当前位置*/}
                {this.renderPosition()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }

    renderBtn() {
        let data = this.sysConfigGetValueByKey('recycleAutoDelTime','0');
        data = parseInt(data/(1000 * 60 * 60 * 24))
        return (
            <div style={{display: 'flex'}}>
                <div style={{width: '80%'}}>
                    {this.state.first?<Button style={{marginRight: 15}} icon={"undo"} onClick={() => {
                        this.reduction(this.state.checkList, 'more')
                    }}>还原</Button>:null}

                    <Button className={'myRemove'} style={{marginRight: 15}} icon={"delete"} type="danger"
                            onClick={() => {
                                this.allDelete()
                            }}
                    >清空回收站
                    </Button>
                    <span style={{color: 'red', marginLeft: '40px'}}>已删除资源，会在{data}天后自动从回收站彻底删除！</span>
                    <style>
                        {
                            `
                                .myRemove.ant-btn.ant-btn-danger:hover, .myRemove.ant-btn.ant-btn-danger:focus {
                                    color: #fff !important;
                                    background-color: #ff7875;
                                    border-color: #ff7875 !important;
                                }
                                `
                        }
                    </style>
                </div>
                {this.state.first ? <div style={{display: 'flex', justifyContent: 'end', width: '20%'}}>
                    <Search
                        placeholder="请输入关键字"
                        allowClear={true}
                        value={this.state.searchText}
                        onSearch={value => {
                            this.setState({searchText: value,page:1}, () => {
                                this.getList()
                            })
                        }}
                        onChange={(e) => {
                            this.setState({searchText: e.target.value})
                        }}
                        style={{width: 224}}
                    />
                </div> : null}
            </div>
        )
    }

    renderData() {
        let columns = [
            {
                title: '名称',
                key: 'name',
                dataIndex: 'name',
                width: this.state.first ? 300 : '80%',
                ellipsis: true,
                render: (text, record) => {
                    return (<div style={{
                        cursor: 'pointer', width: this.state.first ? 280 : '80%', overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }} onClick={() => {
                        if (this.state.first && record.fileTypeEnum === 'DIR') {
                            this.state.RootId = record.virtualFileId;
                            this.state.currentId = record.virtualFileId;
                            this.state.first = false
                        } else {
                            this.state.currentId = record.id
                        }
                        if (record.fileTypeEnum === 'DIR') {
                            this.setState({page:1},()=>{
                                this.getTwoList(record)
                            })

                        }
                    }} title={text}>

                        <img src={record.icon} style={{width: '24px', height: '24px', objectFit: "contain"}}/>
                        <span style={{color: "rgba(0, 0, 0, 0.85)", fontSize: "16px", marginLeft: '8px'}}>{text}</span>

                    </div>)
                }
            }];
        if (this.state.first && this.state.resourceName === '个人资源') {
            columns.push({
                title: '操作人员',
                dataIndex: 'userName',
            })
        }
        if (this.state.first) {
            columns.push({
                title: '删除时间',
                dataIndex: 'createTime',
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            })

            columns.push({
                title: '自动彻底删除时间',
                dataIndex: 'autoDeleteTime',
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            })
        }
        columns.push({
            title: '大小',
            dataIndex: 'size',
            render: (text, record) => {
                if (record.fileTypeEnum === 'DIR') {
                    return (<div style={{textIndent: '13px'}}>{'-'}</div>)
                } else {
                    return (<div>{text > 0 ? changeSize(text) : 0 + 'b'}</div>)
                }

            }
        });
        if (this.state.first) {
            columns.push({
                title: '操作',
                dataIndex: 'address',
                render: (text, record) => {
                    let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                    return (<div style={{color: newSecondSelectColor,}}>
                        <span style={{cursor: "pointer"}} onClick={() => {
                            this.reduction(record, 'one')
                        }}>还原</span>
                        <span style={{marginLeft: '20px', cursor: "pointer", color: 'red'}} onClick={() => {
                            this.delete(record)
                        }}>彻底删除</span>
                    </div>)
                }
            })
        }
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.checkList = selectedRows;
                this.setState({}, () => {

                })
            },
        };
        const positionHeight=41;
        return (
            <div>
                <PageTableComponent
                    positionHeight={positionHeight}
                    columns={columns}
                    rowSelection={rowSelection}
                    data={this.state.data}
                    page={this.state.page}
                    size={this.state.size}
                    count={this.state.count}
                    onChangePage={(page, size) => {
                        this.onChangePage(page, size)
                    }}
                ></PageTableComponent>
                <Detailpage onRef={(Detailpage) => this.setDetailpage = Detailpage}
                            dataList={this.state.data}></Detailpage>
            </div>

        )
    }
   


    //翻页
    onChangePage(page, size) {
        this.setState({page: page, size: size,selectedRowKeys:[], selectedRows:[]}, () => {
            if(this.state.first){
                this.getList(this.state.recycleType)
            }else{
                this.getTwoList()
            }

        })
    }
    //获取位置
    renderPosition() {
        return (
            <div style={{marginTop:24}}>
                <Position onRef={(position) => this.setPosition = position} backList={this.state.backList}
                          onSaveCallback={(id) => {
                              if (id < 10) {
                                  this.setState({first: true, searchText: '',page:1}, () => {
                                      this.getList()
                                  })
                              } else {
                                  this.setState({currentId: id,page:1}, () => {
                                      this.getTwoList()
                                  })

                              }
                          }}></Position>
            </div>



        )
    }

    //清空回收站
    allDelete() {
        confirm({
            title: '回收站内的所有文件将无法恢复，您确认要清空回收站？',
            onOk: () => {
                this.request({
                    url: "/cm-sites-storage-management/recycle/emptyRecycle?" + 'recycleType=' + this.state.recycleType,
                    method: "post",
                    callBack: (data) => {
                        if (data) {
                            this.setState({first:true},()=>{
                                this.getList()
                            })
                        }
                    }
                });
            },
            onCancel() {
            },
        });


    }

// 获取回收站列表
    getList() {
        let url = "/cm-sites-storage-management/recycle/recycleList?page=" + this.state.page + '&size=' + this.state.size;
        let parms = {
            page: this.state.page,
            size: this.state.size,
            resourceName: this.state.searchText,
            recycleType: this.state.resourceType
        };

        this.request({
            url: url,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    this.setState({data: data.data, count: data.count});
                    this.setPosition.getPosition('', '', this.state.backList)
                }
            }
        });
    }

    getTwoList() {
        this.request({
            url: "/cm-sites-storage-management/recycle/recycleSearch?page=" + this.state.page + '&size=' + this.state.size + '&fid=' + this.state.currentId,
            method: "get",
            body: '',
            callBack: (data) => {
                if (data) {
                    this.setState({data: data.data, count: data.count, first: false});
                    this.setPosition.getPosition(this.state.currentId, this.state.RootId, this.state.backList)
                }
            }
        });
    }

    //彻底删除
    delete(record) {
        let parms = [];
        parms.push(record.id);
        confirm({
            title: '文件删除后将无法恢复，您确认要彻底删除所选文件？',
            onOk: () => {
                this.request({
                    url: "/cm-sites-storage-management/recycle/batchDelete",
                    method: "post",
                    body: parms,
                    contentType: "json",
                    callBack: (data) => {
                        if (data) {
                            if (this.state.data.length === 1) {
                                this.onChangePage(this.state.page - 1, this.state.size)
                            } else {
                                this.onChangePage(this.state.page, this.state.size)
                            }
                        }
                    }
                });
            },
            onCancel() {
            },
        });
    }

    //还原
    reduction(record, status) {
        let that = this;
        let parms = [];
        if (status === 'one') {
            parms.push(record.id)
        } else if (status === 'more') {
            if (record.length) {
                record.forEach((item, index) => {
                    parms.push(item.id)
                })
            } else {
                message.error("请至少选择一个文件或文件夹");
            }
        }
        if (parms.length) {
            confirm({
                title: '确定要将所选项还原？',
                onOk: () => {
                    this.request({
                        url: "/cm-sites-storage-management/recycle/batchRestore",
                        method: "post",
                        body: parms,
                        contentType: "json",
                        callBack: (data) => {
                            if (data) {
                                this.state.selectedRowKeys = [];
                                this.state.selectedRows = [];
                                this.setState({},()=>{
                                    if(status==='one'){
                                        if (this.state.data.length === 1) {
                                            this.onChangePage(this.state.page - 1, this.state.size)
                                        } else {
                                            this.onChangePage(this.state.page, this.state.size)
                                        }
                                    }else{
                                        let count = this.state.count;
                                        let size = this.state.size;
                                        let page = this.state.page;
                                        let pageSum =Math.ceil( count/size);
                                        let dataLength = this.state.data-this.state.checkList.length;
                                            if(dataLength === 0){
                                                if(pageSum == page){	//最后一页
                                                    page = page > 1 ? page-1 : 1
                                                }else{
                                                    page = page
                                                }
                                            }
                                        this.onChangePage(page,this.state.size)

                                        }


                                })
                            }
                        }
                    });
                },
                onCancel() {

                },
            });
        }


    }


}